"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("../button"));
require("./button-kit.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Provides a container for up to 2 buttons, implemented primarily
 * for a Confirm/Cancel button model.
 */

var ButtonKit = function ButtonKit(_ref) {
  var confirmText = _ref.confirmText,
    onConfirm = _ref.onConfirm,
    confirmHref = _ref.confirmHref,
    confirmProps = _ref.confirmProps,
    cancelText = _ref.cancelText,
    onCancel = _ref.onCancel,
    cancelHref = _ref.cancelHref,
    cancelProps = _ref.cancelProps,
    className = _ref.className;
  if (!cancelText && !confirmText) {
    return null;
  }
  var cancelCustomProps = Object.assign({}, {
    visualStyle: 'textOnly'
  }, cancelProps);
  var confirmCustomProps = Object.assign({}, {
    visualStyle: 'positive'
  }, confirmProps);
  var containerClasses = 'buttonContainer'.concat(" pt5 ", className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClasses
  }, cancelText && /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: "m1",
    href: !onCancel && cancelHref ? cancelHref : undefined,
    onClick: onCancel
  }, cancelCustomProps), cancelText), confirmText && /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: "m1",
    href: !onConfirm && confirmHref ? confirmHref : undefined,
    onClick: onConfirm
  }, confirmCustomProps), confirmText));
};
ButtonKit.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Provides display text for and enables the primary button.
   * (right-most button when two buttons are used)
   */
  confirmText: _propTypes["default"].node,
  /**
   * If given, provides the onClick action for the primary button.
   * Takes precedence over the confirmHref prop, if both are given.
   */
  onConfirm: _propTypes["default"].func,
  /**
   * An alternate to the onConfirm action. If given, provides a link to a location
   * for a primary button click. If onConfirm prop is also given, it will take
   * precedence over the given href.
   */
  confirmHref: _propTypes["default"].string,
  /**
   * Optional primary button props
   */
  confirmProps: _propTypes["default"].object,
  /**
   * Provides display text for and enables the secondary button.
   * (left-most when two buttons are used)
   */
  cancelText: _propTypes["default"].node,
  /**
   * If given, provides the onClick action for the secondary button.
   * Takes precedence over the cancelHref prop, if both are given.
   */
  onCancel: _propTypes["default"].func,
  /**
   * An alternate to the onCancel action. If given, provides a link to a location
   * for a secondary button click. If onCancel prop is also given, it will take
   * precedence over the given href.
   */
  cancelHref: _propTypes["default"].string,
  /**
   * Optional secondary button props
   */
  cancelProps: _propTypes["default"].object,
  /**
   * Augments the default button container className.
   */
  className: _propTypes["default"].string
} : {};
var _default = exports["default"] = ButtonKit;